import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/LP/MobileAppDevelopment'

const MobileAppDevelopment: React.FC = () => {
  return (
    <>
      <CustomHead
        keyword={'スマホアプリ開発 モバイルアプリ開発 アプリ開発 UX/UIデザイン'}
        image={'https://aitria.co.jp/img/ogp_mobile_app_development.png'}
        url={'https://aitria.co.jp/services/mobile-app-development/'}
        title="スマホアプリ開発 | Aitria（アイトリア）"
        description="企画設計・UX/UIデザインからアプリ開発・運用まで、一気通貫でのご支援。リリース後のビジネス成長を見据えたモバイルアプリ開発は、Aitria（アイトリア）にお任せください。"
      />
      <Template />
    </>
  )
}

export default MobileAppDevelopment
